import { del, get, patch, post } from "@/lib/api-client-v2";
import type {
  ReferenceLayer,
  ReferenceLayerAccessPolicy,
  ReferenceLayerCreatePayload,
  ReferenceLayerPolicyCreatePayload,
  ReferenceLayerProbeResult,
  ReferenceLayerUpdatePayload,
} from "@/types/reference-layer";

const BASE = "/reference-layers";

export const referenceLayersApi = {
  listForUser: () => get<ReferenceLayer[]>(BASE),

  adminList: () => get<ReferenceLayer[]>(`${BASE}/admin/all`),

  adminCreate: (payload: ReferenceLayerCreatePayload) =>
    post<ReferenceLayer>(`${BASE}/admin`, payload),

  adminUpdate: (id: number, payload: ReferenceLayerUpdatePayload) =>
    patch<ReferenceLayer>(`${BASE}/admin/${id}`, payload),

  adminDelete: (id: number) => del<void>(`${BASE}/admin/${id}`),

  adminProbe: (id: number) =>
    post<ReferenceLayerProbeResult>(`${BASE}/admin/${id}/probe`, {}),

  listPolicies: (layerId: number) =>
    get<ReferenceLayerAccessPolicy[]>(`${BASE}/admin/${layerId}/policies`),

  createPolicy: (layerId: number, payload: ReferenceLayerPolicyCreatePayload) =>
    post<ReferenceLayerAccessPolicy>(`${BASE}/admin/${layerId}/policies`, payload),

  deletePolicy: (layerId: number, policyId: number) =>
    del<void>(`${BASE}/admin/${layerId}/policies/${policyId}`),
};
